// src/utils/constants.js
import authConfig from '../config/auth.config';

export const CONSTANTS = {
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL,
  UAT_EVENTUS_URL: authConfig.REDIRECT_URL, 
  AUTH_SERVICE_URL: authConfig.API_BASE_URL,
  REFRESH_INTERVAL: 300, // seconds
  REGIONS: ['AUH', 'BOM', 'SIN', 'RUH', 'JNB'],
};